import { formatters } from '@utils/formattersV2';
import { HighlightsText } from '../../../../domain/text/highlights-text';
import {
  Lci3SalesMetrics,
  VisitMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { nanoid } from 'nanoid';

type SalesMetricsKey = keyof Pick<
  Lci3SalesMetrics,
  'incrementalSalesLift' | 'incrementalSales' | 'totalProjectedSales'
>;

type SalesMetricsInput = Record<
  SalesMetricsKey,
  Lci3SalesMetrics[SalesMetricsKey]['total']
> &
  Pick<VisitMetrics, 'uniqueUsers'>;

export const salesHighlightsText: HighlightsText<SalesMetricsInput> = props => {
  const usersString = formatters.users(props.metrics.uniqueUsers, {
    full: true,
  });
  const totalProjectedSalesString = formatters.currency(
    props.metrics.totalProjectedSales,
    { full: true, decimals: 0 }
  );
  const incrementalSalesLiftString = formatters.lift(
    props.metrics.incrementalSalesLift
  );
  const incrementalSalesString = formatters.currency(
    props.metrics.incrementalSales,
    { full: true, decimals: 0 }
  );

  return [
    'The ',
    props.campaignName,
    ' campaign reached ',
    props.formatValues.uniqueUsers(usersString, nanoid()),
    ' users who purchased ',
    props.formatValues.totalProjectedSales(totalProjectedSalesString, nanoid()),
    ' after being exposed. Compared to the control, the matched exposed users had ',
    props.formatValues.incrementalSalesLift(
      incrementalSalesLiftString,
      nanoid()
    ),
    ' more purchases which is indicated by the Incremental Sales Lift. The campaign generated ',
    props.formatValues.incrementalSales(incrementalSalesString, nanoid()),
    ' in Incremental Sales that would not have occurred without exposure to this campaign.',
  ];
};
